import React from 'react';
import {BaseMixin, ElementaryMixin, ContentMixin} from '../common/common.js';

import './modal-footer.less';

export default React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    ContentMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Modal.Footer',
    classNames: {
      main: 'uu5-bricks-modal-footer modal-footer'
    },
    defaults: {
      parentTagName: 'UU5.Bricks.Modal'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  componentWillMount: function () {
    this.checkParentTagName(this.getDefault().parentTagName);
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return (
      <div {...this.buildMainAttrs()}>
        {this.getChildren()}
        {this.getDisabledCover()}
      </div>
    );
  }
  //@@viewOff:render
});


// WEBPACK FOOTER //
// ./bricks/modal-footer.js